<template>
  <div id="stakeholdersTop">
    <el-card
      v-if="['desktop', 'laptop'].includes($mq)"
      class="mainCard clear-card defaultCursor"
      shadow="hover"
      :body-style="{padding: '20px 30px'}"
    >
      <div class="title">
        {{ $t('aside.stakeholders') }}
      </div>

      <div class="layout">
        <div class="description left">
          {{ $t('leader.coworker.pageDesc') }}
        </div>
        <div class="right">
          <el-button
            type="primary"
            class="editButton"
            round
            @click="toggleAdd"
          >
            + {{ $t('common.add') }}
          </el-button>
        </div>
      </div>
    </el-card>

    <div
      v-else
      class="cardMobile"
    >
      <div class="header">
        <el-row
          type="flex"
        >
          <el-col
            class="title"
            :span="24"
          >
            {{ $t('aside.stakeholders') }}
          </el-col>
        </el-row>
      </div>
      <div class="contentsWrap">
        <div class="content">
          {{ $t('leader.coworker.pageDesc') }}
        </div>
        <el-button
          type="plain"
          class="editButton clearButton"
          round
          @click="toggleAdd"
        >
          + {{ $t('common.add') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addDialog: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggleAdd() {
      this.$emit('update:addDialog', !this.addDialog);
    },
  },
};
</script>

<style lang="scss" scoped>
#stakeholdersTop {
  .mainCard {
    text-align: left;

    .layout {
      display: flex;
      justify-content: space-between;

      .left {
        margin-right: 10px;
        box-sizing: border-box;
      }

      .right {
        .el-button {
          width: 100px;

          /* padding: 13px 0; */
          padding-left: 18px;
        }
      }
    }

    .title {
      font-weight: bold;
      margin-bottom: 10px;
    }
  }

  .cardMobile {
    color: var(--themeFontColor);

    .header {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 25px;

      .title {
        align-self: center;
      }
    }

    .contentsWrap {
      display: flex;
      align-items: center;

      .editButton {
        padding-left: 18px;
        margin-left: 5px;

        &.clearButton {
          background: transparent;
          color: var(--themeFontColor);
          border-color: var(--themeFontColor);
        }
      }
    }
  }
}
</style>
